import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n                        <li class=", " ref=", " @click=", ">\n                            <div class=", "></div>\n                        </li>\n                    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n                        <rv-slide .work=", " ref=", " .useTransition=", "></rv-slide>\n                    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <div class=\"u-hidden\" class=", " ref=", ">\n                <div class=", ">\n                    ", "\n                </div>\n\n                <ul class=", " ref=", ">\n                    ", "\n                </ul>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import store from 'lib/store';
import Slide from 'components/home-slide';
import { ref } from 'lib/lit-ref';
import Swipe from 'lib/swipe';
import sniffer from 'sniffer';
import anime from 'animejs';
import * as styles from './styles';
const COUNT = 3;
export default class Home extends Component {
  init() {
    this.current = -1;
    this.timer = -1;
    this.swipeTimer = -1;
  }

  render() {
    let works = store.get('content').work.slice(0, COUNT); // TODO: filter by then THEN slice

    return html(_templateObject(), styles.wrapper, ref(this, 'wrapper'), styles.carousel, works.map((work, i) => html(_templateObject2(), work, ref(this, 'slides'), i === 0)), styles.dots, ref(this, 'dotWrapper'), works.map(work => html(_templateObject3(), styles.dot, ref(this, 'dots'), this.onDotClick, styles.dotInner)));
  }

  onRender() {
    this.classList.add(styles.home);

    if (sniffer.isDevice) {
      this.canSwipe = true;
      this.onSwipe = this.onSwipe.bind(this);
      this.swipe = new Swipe();
      this.swipe.on('drag', this.onSwipe);
    }
  }

  onDotClick(event) {
    let target = event.currentTarget;
    let index = this.refs.dots.indexOf(target);
    this.show(index);
  }

  show(index) {
    if (index == this.current) return;
    this.canSwipe = false;
    clearTimeout(this.timer);
    clearTimeout(this.swipeTimer);
    let prev = this.refs.slides[this.current];

    if (prev) {
      prev.leave();
      this.refs.dots[this.current].classList.remove('is-active');
    }

    let current = this.refs.slides[index];
    current.enter({
      delay: !!prev ? 100 : 0
    });
    this.refs.dots[index].classList.add('is-active');
    this.timer = setTimeout(this.showNext.bind(this), 4500);
    this.swipeTimer = setTimeout(() => {
      this.canSwipe = true;
    }, 500);
    this.current = index;
  }

  showNext() {
    if (this.current >= COUNT - 1) this.show(0);else this.show(this.current + 1);
  }

  onSwipe(event) {
    if (!this.canSwipe) return;
    if (event.direction > 0) this.showNext();else if (event.direction < 0) {
      if (this.current > 0) this.show(this.current - 1);else this.show(COUNT - 1);
    }
  }

  animateIn(params, _complete) {
    this.current = 0;
    this.refs.slides[0].enterFirst({
      delay: 400
    });
    this.refs.dots[0].classList.add('is-active');
    anime({
      targets: this.refs.dotWrapper,
      opacity: [0, 1],
      easing: 'linear',
      duration: 400,
      delay: 2200,
      begin: () => {
        this.refs.wrapper.classList.remove('u-hidden');
      },
      complete: () => {
        this.timer = setTimeout(this.showNext.bind(this), 4500);

        _complete();
      }
    });
  }

  animateOut(params, complete) {
    clearTimeout(this.timer);
    clearTimeout(this.swipeTimer);
    anime({
      targets: this,
      opacity: 0,
      easing: 'easeOutCubic',
      duration: 600,
      complete
    });
  }

  onDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.swipeTimer);
    if (this.swipe) this.swipe.destroy();
  }

}
customElements.define('rv-home', Home);